import { required, yup } from "./CommonValidation";
import * as Yup from 'yup';
export const ContactUsSchema = (type) => { 
    if (type === 'add') {
        return yup({
            name: required("Please enter your name"),
            email: required("Please enter email").email('Please enter a valid email address.'),
            contact_no: required("Please enter contact number"),
            message: required("Please enter message")
        });
    } 
};